import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import api from '@/lib/api';
import { useUserStore } from '@/stores/useUserStore';
import { AuthResponse, LoginRequest } from '@/types/auth';
import { ApiErrorResponse } from '@/types/api';

async function login(data: LoginRequest): Promise<AuthResponse> {
  const response = await api.post<{ data: AuthResponse }>('/auth/login', data);
  return response.data.data;
}

export function useLogin() {
  const setLoggedIn = useUserStore((state) => state.login);

  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      setLoggedIn(data.user, data.token);
      toast.success('Logged in successfully!');
    },
    onError: (error: ApiErrorResponse) => {
      toast.error(error.response?.data?.message || 'Invalid email or password');
    },
  });
}
